import * as React from 'react';
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { allBranchDetail, allDoctorDetail, appointementGetById } from '../../../redux/actions/Files.action';
import { Form } from 'react-bootstrap';
import { downloadVoucher, getAllServices, getConsultant, getConsultantById, getVoucherBill, voucherData, voucherSeating } from '../../../redux/actions/Account.action';
import { useRef } from 'react';
import VoucherBill from '../../voucherBill/Index'
import Index from '../../voucherBill/Index';

export default function GenerateBill() {

    const { id } = useParams()
    const navigate = useNavigate();

    const dispatch = useDispatch()
    const billRef = useRef();
    const branchData = useSelector((state) => state.files)
    const billData = useSelector((state) => state.account)
    console.log('billData', billData);
    const [readyToPrint, setReadyToPrint] = useState(false);
    const newWindowRef = useRef(null);

    const [selectedOption, setSelectedOption] = useState("");
    const [selectedVoucherServiceId, setSelectedVoucherServiceId] = useState("");
    const [selectedBill, setSelectedBill] = useState(null);
    const [formData, setFormData] = useState({ voucerRemark: '' });
    const [allData, setAllData] = useState()
    const [billIds1, setBillIds1] = useState()
    const [serviceIds1, setServiceIds1] = useState()
    const [showMore, setShowMore] = useState(false);
    const [isTableVisible, setIsTableVisible] = useState(false);
    const [voucherId, setvoucherId] = useState()
    const [billIdT, setbillIdT] = useState();
    const [billNameT, setBillNameT] = useState("");
    const [serviceIdT, setserviceIdT] = useState();
    const [serviceNameT, setServiceNameT] = useState("");
    const [billDataArray, setBillDataArray] = useState([]);
    console.log('serviceIdT', serviceIdT);
    console.log('billDataArray', billDataArray);
    console.log("voucherId", voucherId);

    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId;
    console.log("userId", userId);
    const voucherId2 = localStorage.getItem('voucherId');

    const handleChange = (e) => {
        const selectedBillId = e.target.value;
        const selectedRes = billData?.getVoucherBill?.data?.data?.find(bill => bill._id === selectedBillId);
        console.log('selectedBillId', selectedBillId);

        if (selectedRes) {
            setSelectedBill(selectedRes);
            handleGetService(selectedRes);
            setBillNameT(selectedRes.packageName);
        }
        setSelectedOption(e.target.value);
        setBillIds1(e.target.value)
        setbillIdT(selectedBillId)
    };
    const handleVoucherServiceChange = (e) => {
        const selectedServiceId = e.target.value;
        const selectedService = billData?.getConsultantById?.data?.Billing?.packageServices?.find(
            (service) => service.serviceId === selectedServiceId
        );

        if (selectedService) {
            setSelectedVoucherServiceId(selectedServiceId);
            setserviceIdT(selectedServiceId);
            setServiceNameT(selectedService.servicesName); // Store the service name

            setIsTableVisible(true);
            addToBillDataArray(selectedOption, billNameT, selectedServiceId, selectedService.servicesName);
        }
    };
    const addToBillDataArray = (billId, billName, serviceId, serviceName) => {
        if (!billId || !serviceId) {
            console.error("Bill ID or Service ID is missing");
            return;
        }

        setBillDataArray((prevArray) => {
            const existingBillIndex = prevArray.findIndex(
                (item) => item.billId === billId
            );

            if (existingBillIndex !== -1) {
                const updatedArray = [...prevArray];
                const existingBill = updatedArray[existingBillIndex];

                const isServiceExists = existingBill.services.some(service => service.serviceId === serviceId);
                if (!isServiceExists) {
                    existingBill.services.push({ serviceId, serviceName });
                }

                return updatedArray;
            } else {
                return [...prevArray, { billId, packageName: billName, services: [{ serviceId, serviceName }] }];
            }
        });

        setserviceIdT("");
    };

    const handleFormData = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
    };

    const formatDateTime = (isoDate) => {
        const date = new Date(isoDate);
        const formattedDate = date.toLocaleDateString('en-GB');
        const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
        return `${formattedDate} | ${formattedTime}`;
    };

    useEffect(() => {
        if (userId) {
            dispatch(getConsultant(userId))
            dispatch(getVoucherBill(userId))
        }
    }, [userId])

    const handleGetService = (res) => {
        dispatch(getConsultantById(res._id));
    }

    const handleVoucher = () => {
        const payload = {
            patientId: branchData?.getAppointmentById?.data?.appointmentData?.patientId,
            billData: billDataArray.map(bill => ({
                billId: bill.billId,
                serviceId: bill.services.map(service => service.serviceId)
            })),
            voucerRemark: formData.voucerRemark
        };
        console.log('payload--', payload);

        dispatch(voucherSeating(payload)).then(() => {
            setFormData({ voucerRemark: '' });
            setSelectedOption('');
            setSelectedVoucherServiceId('');
            setIsTableVisible(false)
        })
    }

    useEffect(() => {
        dispatch(allBranchDetail())
        dispatch(allDoctorDetail())
        dispatch(getAllServices())
        dispatch(voucherData(userId, serviceIds1, billIds1))
        if (id) {
            dispatch(appointementGetById(id))
        }
    }, [id, userId, allData, selectedOption, selectedVoucherServiceId])

    const handleDownloadVoucher = async (voucherId) => {
        try {
            // Dispatch the API calls and wait for them to complete
            await dispatch(downloadVoucher(userId, voucherId));
            await dispatch(voucherData(userId));

            // Update local state and set the service ID in localStorage
            // setAllData(datas);
            localStorage.setItem('voucherId', voucherId);
            setReadyToPrint(true);

            // Open a new window but wait for data to be ready before writing to it
            const newWindow = window.open('', '_blank');
            newWindowRef.current = newWindow;
        } catch (error) {
            console.error('Error while downloading voucher:', error);
        }
    };

    const handleDeleteService = (billId, serviceId) => {
        setBillDataArray((prevArray) => {
            return prevArray
                .map(bill => {
                    if (bill.billId === billId) {
                        const filteredServices = bill.services.filter(service => service.serviceId !== serviceId);
                        if (filteredServices.length === 0) return null; // Remove bill if no services left
                        return { ...bill, services: filteredServices };
                    }
                    return bill;
                })
                .filter(Boolean);
        });
    };

    useEffect(() => {
        console.log('readyToPrint', readyToPrint, allData, newWindowRef.current);
        if (readyToPrint && newWindowRef.current) {
            const newWindow = newWindowRef.current;
            const content = billRef?.current?.innerHTML;

            console.log("✅ Voucher content:", content);
            if (!content || content.trim() === '') {
                newWindow.document.write("<h1>Error: Voucher content is empty</h1>");
                return;
            }

            newWindow.document.write(`
                <html>
                    <head>
                        <title>Voucher</title>
                        <style>
                            body {
                                font-family: Arial, sans-serif;
                                padding: 20px;
                                margin: 0;
                                background-color: #fff;
                            }
                            .content {
                                max-width: 595pt;
                                min-height: 842pt;
                                margin: auto;
                                background-color: #fff;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="content">                            
                            ${content}
                        </div>
                    </body>
                </html>
            `);

            newWindow.document.close();

            newWindow.onload = () => {
                newWindow.print();
                newWindow.onafterprint = () => {
                    newWindow.close();
                };
            };

            setReadyToPrint(false);
        }
    }, [readyToPrint, allData]);

    return (
        <>
            <div className="mt-[100px]">
                <div className='row my-4'>
                    <div className="col items-center">
                        <h5 className='mb-0'>Generate Voucher</h5>
                    </div>
                </div>

                <div className='row justify-content-between border-t py-4'>
                    <div className='col-6'>
                        <div className='flex items-center gap-3'>
                            <label className='block'>Patient Name :</label>
                            <div className="inline-flex gap-2 !text-gray-600 rounded-3 px-3 border-1 mt-1 items-center">
                                <h6 className="mb-0 text-sm">{branchData?.getAppointmentById?.data?.appointmentData?.firstName} {" "} {branchData?.getAppointmentById?.data?.appointmentData?.lastName}</h6>
                                <h6 className="border-l-[1px]  text-sm mb-0 py-2 px-2 !border-[#dadada] ">
                                    +91 {branchData?.getAppointmentById?.data?.appointmentData?.phoneNumber}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='my-5'>
                    <div className='row gy-4'>
                        <div className="col-3">
                            <div className=''>
                                <label htmlFor="bill" className='mb-1'>Select Bill</label>
                                <Form.Select onChange={handleChange} value={selectedOption} className='inline-flex shadow-none outline-none focus:!border-theme-dark'>
                                    <option value="">Select Bill</option>
                                    {
                                        billData?.getVoucherBill?.data?.data?.map((res) => {
                                            return (
                                                <>
                                                    {
                                                        res.type === 'PACKAGE' && (
                                                            <option key={res._id} value={res._id}>{res.packageName}</option>
                                                        )
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </Form.Select>
                            </div>
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Voucher for visit</label>
                            <Form.Select onChange={handleVoucherServiceChange} value={selectedVoucherServiceId} className='shadow-none outline-none focus:!border-theme-dark'>
                                <option value="">Select Voucher</option>
                                {
                                    billData?.getConsultantById?.data?.Billing?.packageServices?.map((res) => {
                                        return (
                                            <option key={res._id} value={res.serviceId}>{res.servicesName}</option>
                                        )
                                    })
                                }
                            </Form.Select>
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Doctor Name</label>
                            <Form.Group controlId="campaignDetail">
                                <div className="relative">
                                    <input
                                        name="doctorName"
                                        readOnly
                                        value={branchData?.getAppointmentById?.data?.appointmentData?.doctor}
                                        className="border w-full outline-none focus:!border-theme-dark rounded py-[6px] px-[12px]"
                                    />
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Branch</label>
                            <Form.Control readOnly value={branchData?.getAppointmentById?.data?.appointmentData?.branch} className='shadow-none outline-none focus:!border-theme-dark' />
                        </div>
                        <div className="col-3">
                            <label htmlFor="bill" className='mb-1'>Appointment Date Time</label>
                            <Form.Control
                                type='text'
                                readOnly
                                value={branchData?.getAppointmentById?.data?.appointmentData?.dateOfAppointment
                                    ? formatDateTime(branchData?.getAppointmentById?.data?.appointmentData?.dateOfAppointment)
                                    : ''}
                                placeholder='Appointment date time'
                                className='shadow-none focus:!border-theme-dark'
                            />
                        </div>
                        <div className='col-3'>
                            <label htmlFor="bill" className='mb-1'>Remark</label>
                            <textarea name="voucerRemark" value={formData.voucerRemark} onChange={handleFormData} placeholder='Enter Remark' className='border w-full rounded-lg px-3 py-2 outline-none'></textarea>
                        </div>
                    </div>
                </div>

                {isTableVisible && billDataArray.length > 0 && (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Package Name</th>
                                <th>Service Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {billDataArray.map((bill) =>
                                bill.services.map((service, index) => (
                                    <tr key={bill.billId + service.serviceId}>
                                        <td>{bill.packageName}</td>
                                        <td>{service.serviceName || "Unknown"}</td>
                                        <td>
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => handleDeleteService(bill.billId, service.serviceId)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}

                <div className='mt-4 flex items-center gap-3'>
                    <button className='px-4 py-1 bg-theme-dark text-white rounded-lg' onClick={handleVoucher}>Submit</button>
                </div>


                {/* <div className='mt-5'>
                    <h4>History</h4>
                    <TableContainer>
                        <Table variant="striped" colorScheme="blackAlpha">
                            <Thead>
                                <Tr>
                                    <Th>Bill Name</Th>
                                    <Th>Service Name</Th>
                                    <Th>Remark</Th>
                                    <Th>Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {billData?.voucherData?.data?.data?.length > 0 ? (
                                    <>
                                        {billData?.voucherData?.data?.data
                                            .slice(0, showMore ? billData.voucherData.data.data.length : 3)
                                            .map((res, index) => (
                                                <Tr key={index}>
                                                    <Td>{res.packageName}</Td>
                                                    <Td>{res.serviceName}</Td>
                                                    <Td>{res.voucerRemark}</Td>
                                                    <Td>
                                                        <button
                                                            className='px-4 py-2 bg-theme-dark text-white rounded-lg'
                                                            onClick={() => { handleDownloadVoucher(res?.serviceId, res.patientDetails); setvoucherId(res?.billNumber) }}
                                                        >
                                                            Print
                                                        </button>
                                                    </Td>
                                                </Tr>
                                            ))
                                        }
                                        <Tr>
                                            <Td colSpan={4} className="text-end">
                                                <button
                                                    className='text-theme-dark underline'
                                                    onClick={() => setShowMore(!showMore)}
                                                >
                                                    {showMore ? 'Show Less' : 'Show More'}
                                                </button>
                                            </Td>
                                        </Tr>
                                    </>
                                ) : (
                                    <Tr>
                                        <Td colSpan={4} className="text-center">No Voucher Data</Td>
                                    </Tr>
                                )}
                            </Tbody>

                        </Table>
                    </TableContainer>
                </div> */}
                <div className='mt-5'>
                    <h4>History</h4>
                    <TableContainer>
                        <Table variant="striped" colorScheme="blackAlpha">
                            <Thead>
                                <Tr>
                                    <Th>Voucher</Th>
                                    <Th>Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {billData?.voucherData?.data?.data?.length > 0 ? (
                                    <>
                                        {billData.voucherData.data.data
                                            .slice(0, showMore ? billData.voucherData.data.data.length : 3)
                                            .map((res, index) => (
                                                <Tr key={index}>
                                                    <Td>Voucher {index + 1}</Td>
                                                    <Td>
                                                        <button
                                                            className='px-4 py-2 bg-theme-dark text-white rounded-lg'
                                                            onClick={() => {
                                                                handleDownloadVoucher(res?.voucherId);
                                                                setvoucherId(res?.voucherId);
                                                            }}
                                                        >
                                                            Print
                                                        </button>
                                                    </Td>
                                                </Tr>
                                            ))
                                        }
                                        <Tr>
                                            <Td colSpan={2} className="text-end">
                                                <button
                                                    className='text-theme-dark underline'
                                                    onClick={() => setShowMore(!showMore)}
                                                >
                                                    {showMore ? 'Show Less' : 'Show More'}
                                                </button>
                                            </Td>
                                        </Tr>
                                    </>
                                ) : (
                                    <Tr>
                                        <Td colSpan={2} className="text-center">No Voucher Data</Td>
                                    </Tr>
                                )}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </div>
                <div style={{ position: 'absolute', left: '-9999px' }}>
                    <Index billRef={billRef} allData={allData} voucherId={voucherId} />
                </div>
            </div>
        </>
    );
}
